import { jsx as _jsx } from "react/jsx-runtime";
const Div = (props) => _jsx("div", Object.assign({}, props));
export default Div;
